import React, { useEffect } from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import { withTranslation } from "react-i18next";
// import images
import logodark from "../../assets/images/logo-dark.png"
import logolight from "../../assets/images/logo-light.png"

const EmailVerification = (props) => {
  const verificationEmail = localStorage.getItem("verificationEmail")

  useEffect(()=>{
    return ()=>{
      localStorage.removeItem("verificationEmail")
    }
  })
  
  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
          <title>{props.t("EMAIL_VERIFICATION")}</title>
        <Container>
          <Row>
            <Col lg={12}>
              <div className="text-center mb-5 text-muted">
                <Link to="dashboard" className="d-block auth-logo">
                  <img
                    src={logodark}
                    alt=""
                    height="70"
                    className="auth-logo-dark mx-auto"
                  />
                  <img
                    src={logolight}
                    alt=""
                    height="70"
                    className="auth-logo-light mx-auto"
                  />
                </Link>
                {/*<p className="mt-3">React Admin & Dashboard Template</p> */}
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card>
                <CardBody>
                  <div className="p-2">
                    <div className="text-center">
                      <div className="avatar-md mx-auto">
                        <div className="avatar-title rounded-circle bg-light">
                          <i className="bx bxs-envelope h1 mb-0 text-primary"></i>
                        </div>
                      </div>
                      <div className="p-2 mt-4">
                        <h4>{props.t("EMAIL_VERIFICATION")}</h4>
                        <p>
                          {props.t("VERIFICATION_EMAIL_SENT")}
                          <span className="font-weight-semibold">
                          &nbsp;{verificationEmail}
                          </span>
                          
                        </p>
                        <div className="mt-4">
                          <Link
                            to="/login"
                            className="btn btn-success w-md"
                          >
                          {props.t("CONNECT")}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
              {/*
              <div className="mt-5 text-center">
                <p>
                  Did&apos;t receive an email ?{" "}
                  <a href="#" className="fw-medium text-primary">
                    {" "}
                    Resend{" "}
                  </a>{" "}
                </p>
                <p>
                  © {new Date().getFullYear()} Skote. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger"></i> by Themesbrand
                </p>
              </div>
              */}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
export default withTranslation()(EmailVerification)
//export default EmailVerification
